import Vue from 'vue'

const store = {
    namespaced: true,

    state: {
        reactivityTriggers: {
            volume: {
                matrix: {},
                visibility: {}
            },
            cameraPosition: false,
            sceneSize: false
        }
    },

    getters: {
        cameraPosition: (state) => {
            let dummy = state.reactivityTriggers.cameraPosition;
            return iq3Camera.getConfigurationWorld().position;
        },

        getVolumeWorldMatrix: (state) => (branchId) => {
            let dummy = state.reactivityTriggers.volume.matrix[branchId];
            const volume = modelManager.getVolume(branchId);
            if (!volume) {
                return null;
            }

            const modelObject = getModelObject(volume.modelId);
            if (modelObject?.meshType === MeshTypeEnum.POINT_CLOUD) {
                return getVolumeWorldMatrix(modelObject.modelId, branchId);
            }

            return volume ? getVolumeWorldMatrix(volume.modelId, branchId) : new THREE.Matrix4();
        },

        getVolumeVisibility: (state) => (branchId) => {
            let dummy = state.reactivityTriggers.volume.visibility[branchId];

            const volume = modelManager.getVolume(branchId);
            let modelObject = getModelObject(volume?.modelId || branchId);
            const isPointCloudModel = modelObject?.meshType === MeshTypeEnum.POINT_CLOUD;

            if (!volume && !isPointCloudModel) {
                return false;
            }

            return modelObject?.visible && (isPointCloudModel || volume.volumeVisibility);
        },

        sceneSize: (state) => {
            let dummy = state.reactivityTriggers.sceneSize;
            return wv.sceneSize;
        },
    },

    mutations: {
        INIT_TRIGGER_FOR_VOLUME: function (state, branchId) {
            let matrix = state.reactivityTriggers.volume.matrix;
            if (matrix[branchId] === undefined) {
                Vue.set(matrix, branchId, false);
                Vue.set(state.reactivityTriggers.volume.visibility, branchId, true);
            }
        },

        TRIGGER_VOLUME_MATRIX_UPDATED: function (state, branchId) {
            let matrix = state.reactivityTriggers.volume.matrix;
            if (matrix[branchId] !== undefined) {
                Vue.set(matrix, branchId, !matrix[branchId]);
            }
        },

        TRIGGER_ALL_VOLUME_MATRIX_UPDATED_ON_MODEL: function (state, modelId) {
            let matrix = state.reactivityTriggers.volume.matrix;
            for (let branchId in matrix) {
                const volume = modelManager.getVolume(branchId);
                if (matrix.hasOwnProperty(branchId) &&  volume
                    && volume.modelId === modelId) {
                    Vue.set(matrix, branchId, !matrix[branchId]);
                }
            }
        },

        TRIGGER_ALL_VOLUME_MATRIX_UPDATED: function (state) {
            let matrix = state.reactivityTriggers.volume.matrix;
            for (let branchId in matrix) {
                if (matrix.hasOwnProperty(branchId)) {
                    Vue.set(matrix, branchId, !matrix[branchId]);
                }
            }
        },

        TRIGGER_VOLUME_VISIBILITY_UPDATED: function (state, payload) {
            let visibility = state.reactivityTriggers.volume.visibility;
            if (visibility[payload.branchId] !== undefined) {

                // if same state property is set again, the component doesn't render.
                // hence we are toggling before to set the final state
                Vue.set(visibility, payload.branchId, !visibility[payload.branchId]);
                if (payload.hasOwnProperty('visible') && visibility[payload.branchId] !== payload.visible) {
                    Vue.set(visibility, payload.branchId, payload.visible);
                }
            }
        },

        TRIGGER_ALL_VOLUME_VISIBILITY_UPDATED_ON_MODEL: function (state, payload) {
            let visibility = state.reactivityTriggers.volume.visibility;
            for (let branchId in visibility) {
                const volume = modelManager.getVolume(branchId);
                if (visibility.hasOwnProperty(branchId) && volume
                    && volume.modelId === payload.modelId) {
                    Vue.set(visibility, branchId, !visibility[branchId]);
                    if (payload.hasOwnProperty('visible') && visibility[branchId] !== payload.visible) {
                        Vue.set(visibility, branchId, payload.visible);
                    }
                }
            }
        },

        REMOVE_TRIGGER_FOR_MODEL: function (state, modelId) {
            let matrix = state.reactivityTriggers.volume.matrix;
            let visibility = state.reactivityTriggers.volume.visibility;
            for (let branchId in matrix) {
                const volume = modelManager.getVolume(branchId);
                if (matrix.hasOwnProperty(branchId) && isVolumeExists(branchId)
                    &&volume.modelId === modelId) {
                    Vue.delete(matrix, branchId);
                    Vue.delete(visibility, branchId);
                }
            }
        },

        TRIGGER_CAMERA_POSITION_UPDATED: function (state) {
            state.reactivityTriggers.cameraPosition = !state.reactivityTriggers.cameraPosition;
        },

        TRIGGER_SCENE_SIZE_UPDATED: function (state) {
            state.reactivityTriggers.sceneSize = !state.reactivityTriggers.sceneSize;
        }
    }
};

export default function register(rootStore) {
    rootStore.registerModule('garbage_can', store);

    iq3Camera.addEventListener('change', () => {
        rootStore.commit('garbage_can/TRIGGER_CAMERA_POSITION_UPDATED');
    });

    wv.rootObject.addEventListener(RotationEvent.type, () => {
        rootStore.commit('garbage_can/TRIGGER_ALL_VOLUME_MATRIX_UPDATED');
    });

    wv.rootObject.addEventListener(ModelEvents.LOAD, () => {
        rootStore.commit('garbage_can/TRIGGER_SCENE_SIZE_UPDATED');
    });

    wv.rootObject.addEventListener(ModelEvents.UNLOAD, () => {
        rootStore.commit('garbage_can/TRIGGER_SCENE_SIZE_UPDATED');
    });
}
